
export const units = {
  length: [
    "meter", "kilometer", "centimeter", "mile", "yard", "foot", "inch",
    "nautical mile", "fathom", "cable",
    "ell", "rod", "furlong", "league",
    "cubit", "roman foot", "span", "palm"
  ],
  weight: [
    "kilogram", "pound", "ounce", "gram", "milligram", "ton",
    "carat", "grain",
    "stone", "dram", "talent", "shekel"
  ],
  volume: [
    "liter", "milliliter", "fluid ounce", "gallon", "cubic meter", "quart", "pint",
    "gill", "hogshead", "firkin", "butt",
    "bushel", "peck", "pottle"
  ],
  temperature: [
    "celsius", "fahrenheit", "kelvin",
    "reaumur", "rankine"
  ],
  time: [
    "second", "minute", "hour", "day", "week", "month", "year",
    "fortnight", "moment", "jiffy"
  ],
  area: [
    "square meter", "acre", "hectare", "square kilometer", "square mile",
    "barn", "morgen", "hide", "chain"
  ],
  speed: [
    "meters per second", "miles per hour", "kilometers per hour",
    "knot", "furlong per fortnight"
  ]
};
